import { useState } from "react";
import { supabase } from "../services/adminApi";
import { isSupabaseConfigured } from "../../backend/lib/supabaseClient";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setBusy(false);
      setError(error.message);
      return;
    }

    const { data: user } = await supabase
      .from("users")
      .select("role")
      .eq("id", data.user.id)
      .single();

    if (user?.role !== "admin") {
      await supabase.auth.signOut();
      setBusy(false);
      setError("This account does not have admin access.");
      return;
    }

    navigate("/admin");
  };

  return (
    <div className="admin-login">
      <h2>✦ Celestial Stones ✦</h2>
      <form onSubmit={handleLogin}>
        <p className="login-subtitle">Admin Panel</p>
        {!isSupabaseConfigured && (
          <p className="error">
            Supabase environment variables are missing on this deployment.
            Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY, then
            redeploy.
          </p>
        )}
        <input
          type="email"
          placeholder="Email"
          value={email}
          autoComplete="username"
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={busy || !email || !password}>
          {busy ? "Signing in…" : "Login"}
        </button>
      </form>
    </div>
  );
}
